import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { useQuery } from '@apollo/client';
import { useRouter } from 'found';
import Grid from '@mui/material/Grid';
import Main from 'ripple/Containers/Main';
import useIsMobile from 'lib/useIsMobile';
import makeStyles from '@mui/styles/makeStyles';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import NoSsr from '@mui/material/NoSsr';
import { Carousel } from 'react-responsive-carousel';
import bg1 from './asset/bg1.png';
import bg2 from './asset/bg2.png';
import bg3 from './asset/bg3.png';
import ar1 from './asset/ar1.png';
import ar2 from './asset/ar2.png';
import bg from './asset/bgn.png';
import bgm from './asset/bgm.png';
import bnimg from './asset/UGC1.gif';
import uparrow from './asset/uparrow.png';
import downarrow from './asset/downarrow.png';
import { GET_VIEWER_INFO } from '../../schema/apolloQueries/homePageQueries';

import HouseParty from './asset/houseparty.svg';
import Chatterbox from './asset/chatterbox.svg';
import Chatterbuy from './asset/chatterbuy.svg';
import Refund from './asset/refund.svg';
import Brands from './asset/Brands';

const useStyles = makeStyles(theme => ({
  main: {
    background: 'white',
    color: 'black',
    paddingTop: '65px',
    overflow: 'hidden',
    margin: '0 auto',
    width: '100vw',
  },
  top: {
    margin: '0 auto',
    width: '100%',
    minHeight: '55vh',
    position: 'relative',
  },
  topNoSpotLight: {
    margin: '0 auto',
    width: '100%',
    height: '34vw',
    position: 'relative',
  },
  topMob: {
    margin: '0 auto',
    width: '100%',
    height: 375,
    position: 'relative',
    borderRadius: 0,
  },
  heading: {
    fontFamily: 'NewOrderBold',
    fontSize: 70,
    fontWeight: '700',
    textAlign: 'left',
    color: 'white',
    [theme.breakpoints.down('md')]: {
      fontSize: 40,
    },
  },
  headingMobile: {
    fontFamily: 'NewOrderBold',
    fontSize: 28,
    fontWeight: '700',
    textAlign: 'center',
    color: 'white',
    position: 'relative',
    top: '2%',
  },
  subHeading: {
    fontFamily: 'jost',
    fontSize: 32,
    fontWeight: '400',
    textAlign: 'left',
    color: 'white',
    [theme.breakpoints.down('md')]: {
      fontSize: 25,
    },
  },
  subHeadingMobile: {
    fontFamily: 'jost',
    fontSize: 18,
    fontWeight: '400',
    textAlign: 'center',
    color: 'white',
    position: 'relative',
    top: '48%',
    marginTop: '2%',
  },
  getStarted: {
    textAlign: 'center!important',
    width: 174,
    height: 44,
    background: 'none!important',
    color: 'white!important',
    marginTop: '2%!important',
    fontFamily: 'jost!important',
    fontSize: '18px!important',
    cursor: 'pointer!important',
    borderRadius: '75px!important',
    padding: '0.5%!important',
    border: '3px solid white!important',
    '&:hover': {
      color: '#0076BB!important',
      backgroundColor: 'white!important',
    },
  },
  getStartedMobile: {
    textAlign: 'center!important',
    width: 174,
    height: 44,
    background: 'none!important',
    color: 'white!important',
    margin: '0 auto!important',
    top: '50%!important',
    position: 'relative!important',
    fontFamily: 'jost!important',
    fontSize: '18px!important',
    cursor: 'pointer!important',
    borderRadius: '75px!important',
    padding: '2%!important',
    border: '3px solid white!important',
    display: 'flex!important',
    '&:hover': {
      color: '#0076BB!important',
      backgroundColor: 'white!important',
    },
  },
  center: {
    margin: '0 auto',
    position: 'relative',
    textAlign: 'center',
  },
  spotLight: {
    fontFamily: 'NewOrderBold',
    fontSize: '38px',
    fontWeight: '700',
    textAlign: 'left',
    color: '#000000',
    marginTop: '2%',
    marginBottom: '1%',
    paddingLeft: '17%',
  },
  spotLightMobile: {
    fontFamily: 'NewOrderBold',
    fontSize: '22px',
    fontWeight: '700',
    textAlign: 'center',
    color: '#000000',
    marginTop: '2%',
  },
  spotLightImage: {
    width: '90%',
    margin: '0 auto',
    display: 'block',
    maxHeight: '355px',
    marginBottom: '6%',
  },
  spotLightImageMob: {
    width: '90%',
    margin: '0 auto',
    display: 'block',
  },
  spotLightText: {
    fontFamily: 'jost',
    fontSize: '24px',
    fontWeight: '400',
    textAlign: 'left',
    color: '#000000',
    marginTop: '2%',
    marginBottom: '1%',
    paddingLeft: '17%',
  },
  spotLightTextMobile: {
    fontFamily: 'jost',
    fontSize: '18px',
    fontWeight: '400',
    textAlign: 'center',
    color: '#000000',
    marginTop: '2%',
    marginBottom: '1%',
    paddingLeft: '5%',
    paddingRight: '5%',
  },
  letsDoIt: {
    fontFamily: 'jost',
    fontSize: '16px',
    fontWeight: 700,
    textAlign: 'center',
    color: 'white',
    border: '1px solid #0076BB',
    cursor: 'pointer',
    padding: '9px 24px 9px 24px',
    backgroundColor: '#0076BB',
    borderRadius: '75px',
    width: 165,
    height: 44,
    textTransform: 'uppercase',
    marginBottom: '3%',
    marginTop: '2%',
    marginLeft: '17%',
    '&:hover': {
      color: '#0076BB',
      backgroundColor: 'white',
    },
  },
  letsDoItMobile: {
    fontFamily: 'jost',
    fontSize: '16px',
    fontWeight: '700',
    textAlign: 'center',
    color: 'white',
    border: '1px solid #0076BB',
    cursor: 'pointer',
    padding: '9px 24px 9px 24px',
    backgroundColor: '#0076BB',
    borderRadius: '75px',
    width: '165px',
    height: '44px',
    textTransform: 'uppercase',
    margin: '0 auto',
    marginBottom: '3%',
    marginTop: '2%',
    '&:hover': {
      color: '#0076BB',
      backgroundColor: 'white',
    },
  },
  bottom: {
    margin: '0 auto',
    position: 'relative',
    // background: '#E9F5FC',
  },
  bottomHeader: {
    fontFamily: 'NewOrderBold',
    fontSize: '38px',
    fontWeight: '700',
    textAlign: 'center',
    color: '#0076BB',
    margin: '0 auto',
    paddingTop: '2%',
    paddingBottom: '2%',
  },
  bottomHeaderMobile: {
    fontFamily: 'NewOrderBold',
    fontSize: '22px',
    fontWeight: '700',
    textAlign: 'center',
    color: '#0076BB',
    margin: '0 auto',
    paddingTop: '6%',
    paddingBottom: '2%',
  },
  howBg: {
    width: '28vw',
    height: '28vw',
    margin: '0 auto',
    display: 'block',
    [theme.breakpoints.down('sm')]: {
      width: '60vw',
      height: '60vw',
    },
  },
  howHeader: {
    fontFamily: 'jost',
    fontSize: '28px',
    fontWeight: '700',
    textAlign: 'center',
    color: '#000000',
    paddingTop: '3%',
  },
  howHeaderMobile: {
    fontFamily: 'jost',
    fontSize: '20px',
    fontWeight: '700',
    textAlign: 'center',
    color: '#000000',
    paddingTop: '3%',
  },
  howText: {
    fontFamily: 'jost',
    fontSize: '24px',
    fontWeight: '400',
    textAlign: 'center',
    color: 'black',
    paddingTop: '2%',
    paddingBottom: '2%',
    paddingLeft: '7%',
    paddingRight: '7%',
  },
  howTextMobile: {
    fontFamily: 'jost',
    fontSize: '18px',
    fontWeight: '400',
    textAlign: 'center',
    color: 'black',
    paddingTop: '2%',
    paddingBottom: '2%',
    paddingLeft: '8%',
    paddingRight: '8%',
  },
  brandHeader: {
    fontFamily: 'NewOrderBold',
    fontSize: '38px',
    fontWeight: '700',
    textAlign: 'center',
    color: '#0076BB',
    margin: '0 auto',
    paddingTop: '1%',
    paddingBottom: '1%',
  },
  brandHeaderMobile: {
    fontFamily: 'NewOrderBold',
    fontSize: '22px',
    fontWeight: '700',
    textAlign: 'center',
    color: '#0076BB',
    margin: '0 auto',
    paddingTop: '6%',
    paddingBottom: '4%',
  },
  brandsImage: {
    width: '62%',
    margin: '0 auto',
    display: 'block',
  },
  brandsImageMob: {
    width: '62%',
    margin: '0 auto',
    display: 'block',
  },
  showMore: {
    fontFamily: 'jost',
    fontSize: '18px',
    fontWeight: '400',
    textAlign: 'center',
    margin: '0 auto',
    fontStyle: 'italic',
    color: '#0076BB',
    marginTop: '2%',
    border: '2px solid #0076BB',
    borderRadius: 75,
    padding: '0px 10px',
  },
  container: {
    width: 'calc(100% + 24px)',
    margin: '-12px',
    marginBottom: 15,
    display: 'flex',
    flexWrap: 'wrap',
    boxSizing: 'border-box',
  },
  lgGrid: {
    padding: '12px',
    position: 'relative',
    flexGrow: '0',
    maxWidth: '33.333333%',
    flexBasis: '33.333333%',
  },
  lgGridMob: {
    padding: '12px',
    position: 'relative',
    flexGrow: '0',
    maxWidth: '100%',
    flexBasis: '100%',
  },
  waysToExpHeader: {
    fontFamily: 'NewOrderBold!important',
    fontSize: '38px!important',
    textAlign: 'center!important',
    color: `${theme.palette.common.black}!important`,
    fontWeight: '700!important',
    [theme.breakpoints.down('sm')]: {
      fontSize: '22px!important',
    },
  },
  expHeader: {
    fontFamily: 'jost!important',
    fontSize: '24px!important',
    fontWeight: '700!important',
    lineHeight: '32px!important',
    marginBottom: '20px!important',
    color: `${theme.palette.common.black}!important`,
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px!important',
      lineHeight: '26px!important',
      marginBottom: '10px!important',
    },
  },
  expDesc: {
    fontFamily: 'jost!important',
    color: `${theme.palette.common.black}!important`,
    fontSize: '18px!important',
    fontWeight: '400!important',
    lineHeight: '26px!important',
  },
  banner: {
    width: '100%',
    position: 'absolute',
    top: '0',
    [theme.breakpoints.down('md') && theme.breakpoints.up('sm')]: {
      height: '100%',
    },
  },
  bannerMobile: {
    width: '100%',
    position: 'absolute',
    top: '0',
    height: '100%',
  },
  bannerHeadshot: {
    height: '72%',
    width: '22%',
    position: 'absolute',
    top: '14%',
    left: '70%',
    borderRadius: '50%',
    [theme.breakpoints.down('sm')]: {
      height: '23vw',
      width: '23vw',
      top: '4vh',
      left: '69vw',
    },
  },
  bannerHeadshotMobile: {
    position: 'absolute',
    borderRadius: '50%',
    height: '35vw',
    width: '35vw',
    top: '30%',
    left: '32%',
  },
  brandLogoContainer: {
    marginTop: 'auto',
    marginBottom: 'auto',
    alignSelf: 'center',
  },
  brandLogo: {
    padding: '5%',
  },
  brandLogoSlide: {
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingBottom: 20,
    '& .slide': {
      marginTop: 'auto',
      marginBottom: 'auto',
    },
    '& .control-dots .dot': {
      background: '#898989',
    },
  },
  howItWorksArrow1: {
    width: '4vw',
    height: '1.8vw',
    position: 'absolute',
    left: '32vw',
    top: '45%',
    [theme.breakpoints.down('sm')]: {
      top: '25%',
    },
  },
  howItWorksArrow2: {
    width: '4vw',
    height: '1.8vw',
    position: 'absolute',
    left: '32vw',
    top: '17%',
    [theme.breakpoints.down('sm')]: {
      top: '10%',
    },
  },
}));

const HomePage = () => {
  const { router } = useRouter();
  const mobile = useIsMobile();
  const classes = useStyles();
  const [spotEvent, setSpotEvent] = useState(null);
  const [showMore, setShowMore] = useState(false);
  const { data, loading } = useQuery(GET_VIEWER_INFO);

  const experiences = useMemo(
    () => [
      {
        title: 'Throw an epic party',
        icon: { width: 184, height: 121, src: HouseParty },
        description:
          'Be the hostess with the mostest. Celebrate with your besties and experience new products with the people you love.',
      },
      {
        title: 'Unbox your next favorite product',
        icon: { width: 268, height: mobile ? 100 : 121, src: Chatterbox },
        description:
          'Try exciting new brands and products that will get your whole household talking, delivered straight to your doorstep.',
      },
      {
        title: 'Discover something new at your local store',
        icon: { width: 259, height: mobile ? 100 : 121, src: Chatterbuy },
        description:
          'We`ll send you everything you need to make your next shopping trip extra sweet—a gift card or coupon to buy and try new products.',
      },
      {
        title: 'Upload a receipt & get reimbursed',
        icon: { width: 222, height: mobile ? 100 : 121, src: Refund },
        description:
          'Simply claim your spot, shop local, upload a receipt, and we`ll refund your product purchase within two business days.',
      },
    ],
    [mobile],
  );

  useEffect(() => {
    setSpotEvent(null);
    if (
      Array.isArray(data?.fetchSpotLightEvents?.openSpotLightEvents)
      && data.fetchSpotLightEvents.openSpotLightEvents.length > 0
    ) {
      setSpotEvent(data.fetchSpotLightEvents.openSpotLightEvents[0]);
    }
  }, [data]);

  const bannerStyle = useMemo(() => {
    let style = classes.topNoSpotLight;
    if (mobile) {
      style = classes.topMob;
    } else if (spotEvent) {
      // style = classes.top;
    }

    return style;
  }, [classes.topNoSpotLight, classes.topMob, classes.top, mobile, spotEvent]);

  const onClickSpotlightEvent = useCallback(() => {
    if (spotEvent?.slug === 'soccer') {
      router.push(`/${spotEvent?.slug}`);
    } else {
      router.push(`/events/${spotEvent?.slug}`);
    }
  }, [router, spotEvent?.slug]);

  return (
    <Main
      title='Home'
      loading={loading}
      padContent={false}
      padContainerBottom={false}
    >
      <NoSsr>
        <Paper className={classes.main} style={{ backgroundColor: 'white' }}>
          <Grid container spacing={3}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={bannerStyle}>
                <img
                  src={mobile ? bgm : bg}
                  alt='banner'
                  className={mobile ? classes.bannerMobile : classes.banner}
                />
                <img
                  src={bnimg}
                  alt='banner'
                  className={
                    mobile
                      ? classes.bannerHeadshotMobile
                      : classes.bannerHeadshot
                  }
                />
                <div
                  style={{
                    paddingTop: '3%',
                    position: 'relative',
                    ...(mobile ? { height: '100%' } : { marginLeft: '6%' }),
                  }}
                >
                  <div
                    className={mobile ? classes.headingMobile : classes.heading}
                  >
                    Discover New Products <br /> Worth Sharing
                  </div>
                  <div
                    className={
                      mobile ? classes.subHeadingMobile : classes.subHeading
                    }
                  >
                    Access exclusive events and swag-filled <br /> packs from
                    the brands you love.
                  </div>
                  <Button
                    variant='outlined'
                    classes={{
                      root: mobile
                        ? classes.getStartedMobile
                        : classes.getStarted,
                    }}
                    onClick={() => router.push('/discover/events')}
                  >
                    GET STARTED!
                  </Button>
                </div>
              </Card>
            </Grid>
          </Grid>
          {spotEvent && (
            <Grid
              container
              spacing={3}
              style={{
                background: 'rgba(233, 245, 252, 1)',
                // padding: '20px 20px 20px 0px',
                paddingTop: 20,
              }}
            >
              <Grid item lg={5} md={5} sm={12} xs={12}>
                <div>
                  <div
                    className={
                      mobile ? classes.spotLightMobile : classes.spotLight
                    }
                  >
                    Event Spotlight!
                  </div>
                  {!mobile && (
                    <div className={classes.spotLightText}>
                      {spotEvent?.summary}
                    </div>
                  )}
                  {!mobile && (
                    <Button
                      style={{ marginLeft: '17%' }}
                      variant='contained'
                      className={classes.letsDoIt}
                      onClick={onClickSpotlightEvent}
                    >
                      Let’s do it!
                    </Button>
                  )}
                </div>
              </Grid>
              <Grid item lg={7} md={7} sm={12} xs={12}>
                <div className={classes.center}>
                  <img
                    className={
                      mobile
                        ? classes.spotLightImageMob
                        : classes.spotLightImage
                    }
                    src={spotEvent?.heroPlayList?.assets[0]?.hlsPlaylistUrl}
                    alt='img'
                  />
                  {mobile && (
                    <Button
                      className={classes.showMore}
                      onClick={() => setShowMore(!showMore)}
                    >
                      {!showMore ? 'Show more' : 'Show less'}
                      <img
                        style={{
                          width: '29px',
                          height: '12px',
                          position: 'relative',
                          padding: '0px 10px',
                        }}
                        src={showMore ? uparrow : downarrow}
                        alt='arrow'
                      />
                    </Button>
                  )}
                  {mobile && showMore && (
                    <>
                      <div className={classes.spotLightTextMobile}>
                        {spotEvent?.summary}
                      </div>
                      <Button
                        variant='contained'
                        className={classes.letsDoItMobile}
                        onClick={onClickSpotlightEvent}
                      >
                        Let’s do it!
                      </Button>
                    </>
                  )}
                </div>
              </Grid>
            </Grid>
          )}
          <Grid container spacing={3} className={classes.container}>
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className={classes.lgGridMob}
            >
              <div className={classes.bottom}>
                <div
                  className={
                    mobile ? classes.bottomHeaderMobile : classes.bottomHeader
                  }
                >
                  How It Works
                </div>
                <Grid container spacing={3} className={classes.container}>
                  <Grid
                    item
                    lg={4}
                    md={4}
                    sm={12}
                    xs={12}
                    className={mobile ? classes.lgGridMob : classes.lgGrid}
                  >
                    {!mobile && (
                      <img
                        src={ar1}
                        alt='arrow'
                        className={classes.howItWorksArrow1}
                      />
                    )}
                    <img className={classes.howBg} src={bg1} alt='bg' />
                    <div
                      className={
                        mobile ? classes.howHeaderMobile : classes.howHeader
                      }
                    >
                      SIGN UP. It’s free!
                    </div>
                    <div
                      className={
                        mobile ? classes.howTextMobile : classes.howText
                      }
                    >
                      Score buzz-worthy experiences with brands that love to
                      spoil you. Get packs delivered straight to your door
                      that’ll have you hugging the mailman.
                    </div>
                  </Grid>
                  <Grid
                    item
                    lg={4}
                    md={4}
                    sm={12}
                    xs={12}
                    className={mobile ? classes.lgGridMob : classes.lgGrid}
                  >
                    <img className={classes.howBg} src={bg2} alt='bg' />
                    {!mobile && (
                      <img
                        src={ar2}
                        alt='arrow'
                        className={classes.howItWorksArrow2}
                      />
                    )}
                    <div
                      className={
                        mobile ? classes.howHeaderMobile : classes.howHeader
                      }
                    >
                      EXPERIENCE. It’s fun!
                    </div>
                    <div
                      className={
                        mobile ? classes.howTextMobile : classes.howText
                      }
                    >
                      Choose your own Ripple Street adventure! Throw an epic
                      party with your best buds or snag a personal pack for your
                      household to fight over.
                    </div>
                  </Grid>
                  <Grid
                    item
                    lg={4}
                    md={4}
                    sm={12}
                    xs={12}
                    className={mobile ? classes.lgGridMob : classes.lgGrid}
                  >
                    <img className={classes.howBg} src={bg3} alt='bg' />
                    <div
                      className={
                        mobile ? classes.howHeaderMobile : classes.howHeader
                      }
                    >
                      SHARE. It’s easy!
                    </div>
                    <div
                      className={
                        mobile ? classes.howTextMobile : classes.howText
                      }
                    >
                      Be the tastemaker of your friend group. Write product
                      reviews, post on social, and know you’re making a massive
                      impact on what hits shelves next.
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={6}
            style={{
              background: 'rgba(233, 245, 252, 1)',
              padding: '20px 40px',
            }}
          >
            <Grid item sm={12} lg={12} md={12}>
              <Typography classes={{ root: classes.waysToExpHeader }}>
                There Are Many Ways to Experience Ripple Street
              </Typography>
            </Grid>
            {experiences.map(
              ({
                title,
                description,
                icon: { width: iWidth, height: iHeight, src: iSrc },
              }) => (
                <Grid item lg={3} md={6} sm={6} xs={12}>
                  <div
                    style={{
                      height: '100%',
                      padding: '0px 20px',
                      textAlign: 'center',
                    }}
                  >
                    <div
                      style={{
                        height: iHeight,
                        width: iWidth,
                        display: 'block',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                      }}
                    >
                      <img alt={title} src={iSrc} />
                    </div>
                    <div style={{ height: '40%' }}>
                      <Typography className={classes.expHeader}>
                        {title}
                      </Typography>
                      <Typography className={classes.expDesc}>
                        {description}
                      </Typography>
                    </div>
                  </div>
                </Grid>
              ),
            )}
          </Grid>
          <Grid
            container
            spacing={3}
            style={{ padding: `3% 5% ${mobile ? 20 : 4}%` }}
          >
            <Grid
              item
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{ paddingBottom: '0px' }}
            >
              <div
                className={
                  mobile ? classes.brandHeaderMobile : classes.brandHeader
                }
              >
                Just a Few of the Brands You Can Connect With Today
              </div>
            </Grid>
            {mobile ? (
              <Grid
                item
                lg={12}
                md={12}
                sm={12}
                xs={12}
                style={{ paddingTop: '0px' }}
              >
                <Carousel
                  autoPlay
                  infiniteLoop
                  interval={3000}
                  showStatus={false}
                  showThumbs={false}
                  stopOnHover
                  className={classes.brandLogoSlide}
                  style={{ cursor: 'pointer' }}
                >
                  {Brands.map((brand, index) => (
                    <div style={{ margin: '0px 20px 20px' }}>
                      <img
                        alt={index}
                        style={{ maxHeight: 200, width: '60%' }}
                        src={brand}
                        className={classes.brandLogo}
                      />
                    </div>
                  ))}
                </Carousel>
              </Grid>
            ) : (
              Brands.map((brand, index) => (
                <Grid
                  item
                  lg={2}
                  md={3}
                  sm={4}
                  xs={6}
                  className={classes.brandLogoContainer}
                >
                  <img alt={index} src={brand} className={classes.brandLogo} />
                </Grid>
              ))
            )}
          </Grid>
        </Paper>
      </NoSsr>
    </Main>
  );
};

export default HomePage;
